import axios from 'axios'
import Router from '@/router/index'
import { Notification } from 'element-ui'

// 接口环境地址
// let API_ROOT = 'http://172.30.8.101:9982/api'
// let API_ROOT = 'http://192.168.10.158:8080'
let API_ROOT = 'https://pkm.sansure.com.cn/pc'
// process.env.API_ROOT

export default function request (requestOptions = {}) {
  const {
    method = 'get',
    url,
    data = {},
    headers = {},
    noToken = false
  } = requestOptions

  if (method.toLowerCase() === 'get') {
    requestOptions.params = {
      ...data
    }
  } else {
    requestOptions.data = data
  }
  let token = localStorage.getItem('accessToken')
  return axios.request({
    withCredentials: true,
    ...requestOptions,
    url: API_ROOT + url,
    headers: {
      ...headers,
      'Authorization': !noToken ? token : ''
    }
  }).then(({data: res}) => {
    const { code, message } = res
    if (code === '00000') {
      return res.data
    } else {
      // 弹提示
      Notification({
        title: '系统提示',
        message: message
      })
      return Promise.reject(res)
    }
  }).catch(error => {
    const msg = error.response ? error.response.data.message : 'NETWORK_ERROR'
    Notification({
      title: '系统提示',
      message: msg
    })
    if (error.response.data.code === 'B0301') {
      setTimeout(_ => {
        Router.push({ name: 'register' })
      }, 1500)
    }
    return Promise.reject(error)
  })
}



// WEBPACK FOOTER //
// ./src/utils/request.js